var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysCardsOutlined = function SvgSysCardsOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M12.153 5.859H1.537a.922.922 0 0 0-.922.922v6.654c0 .51.413.922.922.922h10.616c.51 0 .922-.413.922-.922V6.78a.922.922 0 0 0-.922-.922Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M.846 8.264h11.989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "m2.492 5.859.37-2.568a.922.922 0 0 1 1.043-.782l10.508 1.51a.922.922 0 0 1 .784 1.044l-.946 6.586a.922.922 0 0 1-1.044.782"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m4.037 3.765 10 1.568"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.913,
    d: "M11.017 11.535h-.925a.71.71 0 1 0 0 1.419h.925a.71.71 0 1 0 0-1.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M2.094 10.813h4.093M2.094 12.735h2.36"
  })));
};
export default SvgSysCardsOutlined;